import moment from 'moment';

const checkIsFutureDate = date => !!date && moment(date).isValid() && moment(date).isAfter(moment());

export default checkIsFutureDate;
